export function pickFile(accept, multiple = false) {
    return new Promise((resolve) => {
        const eltInput = document.createElement('input');
        Object.assign(eltInput, {
            type: 'file',
            accept,
            multiple,
            onchange(e) {
                const { files } = e.target;
                resolve(files);
            },
        }).click();
    });
}
const keyGlyphMapMac = {
    Mod: '⌘',
    Alt: '⌥',
    Shift: '⇧',
    Ctrl: '⌃',
    Tab: '⇥',
    Backspace: '⌫',
    Space: '␣',
    Return: '↩',
    ArrowLeft: '←',
    ArrowRight: '→',
    ArrowUp: '↑',
    ArrowDown: '↓',
};
const keyGlyphMap = {
    Mod: 'Ctrl',
    Alt: 'Alt',
    Shift: 'Shift',
    Ctrl: 'Ctrl',
    ArrowLeft: 'Left',
    ArrowRight: 'Right',
    ArrowUp: 'Up',
    ArrowDown: 'Down',
};
const toCapitalizeLetters = (str) => {
    const first = str.slice(0, 1);
    const tail = str.slice(1);
    return first.toUpperCase() + tail;
};
export const isMac = (ua) => ua.toLowerCase().indexOf('macintosh') > -1;
export function getHostKeyText(keyText) {
    const mac = isMac(navigator.userAgent);
    const glyphMap = mac ? keyGlyphMapMac : keyGlyphMap;
    const pieces = keyText.split('-').map((key) => {
        const text = glyphMap[key] || toCapitalizeLetters(key);
        return text;
    });
    return pieces.join(mac ? '' : '+');
}
//# sourceMappingURL=utils.js.map